// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: "https://appataxi.cab/web_app/public",
  baseUrl: "https://appataxi.cab/client_app/",
  // baseUrl: "http://localhost:5000/",
  // apiUrl: "https://appacab.world/web_app/public",
  // baseUrl: "https://appacab.world/client_app/",
  // apiUrl: "http://44.219.79.202/web_app/public",
  // baseUrl: "http://localhost:5000/",
  // apiUrl: "http://44.219.79.202/web_app/public",
  // apiUrl: "https://stagingpc.com/web_app/public",
  // baseUrl: "http://localhost:5000/",
  firebase: {
    apiKey: "AIzaSyD2EmXo43POdNbBaC77SRNTL4PPAQnnmMk",
    authDomain: "appataxi-1e1f0.firebaseapp.com",
    databaseURL: "https://appataxi-1e1f0.firebaseio.com",
    projectId: "appataxi-1e1f0",
    // storageBucket: "appataxi-1e1f0.firebasestorage.app",
    storageBucket: "appataxi-1e1f0.appspot.com",
    messagingSenderId: "377982103883",
    appId: "1:377982103883:web:39b75969064c61d0",
    vapidKey: "BIbkSKwz2W0be6_jxPIkalbPAP5ygwMFhW_MsAqDQRp9oIQpeiaaPz1IngVgX4qCGtNK7p4HE14od1O1PqCfYt4"
  },
  google: {
    mapApiKey: "AIzaSyBP-RQNwkQGDL0CxqlBSKscf1jJvyyrslo"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
